<template>
  <div
    class="main-slide"
    ref="slide-container"
    id="main-slide"
    :class="{
      'has-share-presentation': sharePresentation,
      'border-base-30 border box-content rounded-md': !isPresenting,
      'is-backstage': isBackstage,
    }"
  >
    <div
      class="slide-container"
      id="slide-container"
      :class="{
        'is-showing-qrcode-panel': isShowingQRCodePanel,
        'is-showing-feedback-panel': isShowingFeedbackPanel,
      }"
      @contextmenu.prevent="handleCanvasRightClick($event)"
    >
      <QuestionImageButton
        v-if="slideActive.activeTab !== 2"
        class="hidden"
      />
      <CanvasRightClickMenu
        :targetX="targetX"
        :targetY="targetY"
        :offsetX="offsetX"
        :offsetY="offsetY"
        :layerX="layerX"
        :layerY="layerY"
        :targetClick="targetClick"
      />
      <ContextMenu
        :show-context-menu="showContextMenu"
        @hideFullScreen="closeContextMenu"
        @hideMenu="closeContextMenu"
        :isShowingQRCodePanel="isShowingQRCodePanel"
        v-if="!sharePresentation"
      />
      <transition
        name="qr-code-panel"
        enter-active-class="animate__animated animate__slideInLeft animate__faster"
        leave-active-class="animate__animated animate__slideOutLeft animate__faster"
      >
        <QRcodePanel v-if="isQRCodeVisible && isPresentingOrBackstage" />
      </transition>
      <transition
        name="feedback-panel"
        enter-active-class="animate__animated animate__slideInRight animate__faster"
        leave-active-class="animate__animated animate__slideOutRight animate__faster"
      >
        <FeedbackPanel
          v-if="isShowingFeedbackPanel"
          :presentation="presentation"
          :slideActive="slideActive"
          @close="isFeedbackPanelOpen = false"
        />
      </transition>
      <FeedbackPanelCollapsedButton
        v-if="isShowingFeedbackCollapseButton"
        :presentation="presentation"
        :slideActive="slideActive"
        @open="onOpenFeedbackPanel"
      />

      <div
        class="backdrop"
        :class="{
          'is-showing-qr-code-panel': isShowingQRCodePanel,
          'is-showing-feedback-panel': isShowingFeedbackPanel,
        }"
        v-if="showContextMenu"
        @mouseenter.stop="closeContextMenu()"
      />
      <div
        class="content-presenting"
        id="main-content-presenting"
        :class="{
          'show-control': isShowingControls || showCheatsheet,
          'is-showing-qrcode-panel': isShowingQRCodePanel,
          'is-showing-feedback-panel': isShowingFeedbackPanel,
        }"
        :style="{'color': slideActive.textColour }"
      >
        <CanvasTransitionBackgroundImage />
        <CanvasPreview v-if="!$store.state.isTouchScreen && !isIOS" wrapperId="right-side" />
        <CanvasChooseASlideType v-if="isChooseASlideTypeVisible" />
        <Slide :key="slideComponentRerenderKey" />
        <LatestLeaderboard v-if="isLeaderboardVisible" class="leaderboard-v2" v-aha-emit-action.view />

        <CheatsheetLayer
          key="cheatsheet"
          v-if="showCheatsheet"
          @click-cheatsheet="hideCheatsheetAction"
        />
        <CanvasLeaderboardMusic />
        <div
          id="canvas-pill"
          :class="{'canvas-pill': !isScreenCapture,
                   'white':isTextColourLight,
                   'no-background': sharePresentation || !isPresenting,
                   'has-chat': isLiveChatVisible,
                   'is-wordcloud-or-openended': isWordCloudOrOpenEnded,
                   'is-wc-submission-locked': isWordCloudSubmissionLocked}"
        >
          <div
            class="slide-menu-toggle__wrapper"
            @click.stop="openContextMenu()"
            @mouseenter.stop="openContextMenu()"
            v-show="isPresenting"
            v-if="!sharePresentation"
          >
            <div class="slide-menu-toggle horizontal layout center">
              <img
                src="@/assets/images/icon/menu-icon.svg"
                class="effect-icon"
                :class="{
                  'white-icon': !isTextColourLight,
                }"
              >
            </div>
          </div>

          <CanvasArrowsNavigation
            @selectPrevSlide="selectPrevSlide"
            @selectNextSlide="selectNextSlide"
            v-if="!isEnableAddinPowerpoint || activePresentationPowerpointId"
          />
          <LiveChat
            class="live-chat__wrapper"
            v-if="isLiveChatVisible"
            :openByDefault="isChatOpenByDefault"
          />
          <CheatsheetToggleButton
            v-show="isPresenting"
            v-if="!isSharingView"
            @toggle-click="toggleCheatsheet"
          ></CheatsheetToggleButton>
          <EffectMenuToogle
            class="effect-menu-toggle__wrapper hover-item"
            :class="{
              'has-chat': isLiveChatVisible,
              'no-chat': !isLiveChatVisible
            }"
            v-show="isPresenting"
            v-if="!isSharingView"
          />
          <LeaderboardVisibilityToggle v-if="isShowLeaderboardVisibilityToggle" />

          <div
            class="result_toggler"
            v-if="!isSharingView"
            v-show="isPresenting"
          >
            <ResultToggler
              :isResultTogglerVisible="isResultTogglerVisible"
              :isShowingResult="!slideActive.hideResult"
              @toggleResult="toggleResult"
              v-if="!isNotHavePlanBenefit"
            />
            <CorrectAnswerToggler
              :isCorrectAnswerTogglerVisible="isCorrectAnswerTogglerVisible"
              @toggleCorrectAnswer="toggleCorrectAnswer"
              :isShowingCorrectAnswer="slideActive.showCorrectOption"
            />
          </div>
          <WordCloudGroupingToggler
            :isShowingGroupWordCloud="slideActive.isGroupWordCloudWords"
            @toggleWordCloudGrouping="handleToggleWordCloudGrouping"
            :isDisabled="noSubmittedWords"
            v-if="isWordCloudGroupingButtonVisible"
          />
          <OpenEndedGroupingButton
            v-if="isOpenEndedGroupingButtonVisible"
          />
          <SubmissionTogglerV2
            v-show="isPresenting"
            v-if="isShowSubmissionToggler"
            :isTextColourLight="isTextColourLight"
            :isShowTimeSubmission="isShowTimeSubmission"
            :isWordCloudGroupingButtonVisible="isWordCloudGroupingButtonVisible"
          />
        </div>
        <div class="show-qna-session" v-if="$store.state.showQnaSession">
          <div class="box-qna-session">
            <QaSession />
          </div>
        </div>
      </div>
      <VoiceCall v-if="voiceCall.isOpen" />
    </div>
    <PowerpointPresenting
      v-if="isEnableAddinPowerpoint && isPresenting && slideActive.id && (!presentation.presenting ||
        presentation.activeSlide !== slideActive.id)"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Hammer from 'hammerjs'
import * as Sentry from '@sentry/vue'
import EventBus from '@/eventBus'
import utils from '@/util'
import configs from '@/config'
import QuizStatuses from '@/constant/QuizStatuses'
import constants from '@/constant'
import Socket from '@/socket'
import storageKeys from '@/constant/storageKeys'
import ToggleQRCodeMixin from '@/mixins/presentation/ToggleQRCodeMixin'
import FeedbackPanelMixin from '@/mixins/presentation/FeedbackPanelMixin'
import SlideApi from '@/api/slide'
import { isIOS } from '@/utils/dom.utils'

import ContextMenu from '@/components/presentations/ContextMenu.vue'
import Slide from '@/components/presentations/Slide.vue'
import CanvasPreview from '@/components-v2/common/canvas-preview/CanvasPreview.vue'
import CanvasChooseASlideType from '@/components-v2/common/canvas-preview/CanvasChooseASlideType.vue'
import CanvasTransitionBackgroundImage from '@/components-v2/presentation-editor/middle/CanvasTransitionBackgroundImage.vue'
import QRcodePanel from '@/components-v2/presentation-editor/middle/QRcodePanel.vue'
import FeedbackPanel from '@/components-v2/presentation-editor/middle/FeedbackPanel.vue'
import FeedbackPanelCollapsedButton from '@/components-v2/presentation-editor/middle/FeedbackPanelCollapsedButton.vue'
import CanvasLeaderboardMusic from '@/components-v2/presentation-editor/middle/CanvasLeaderboardMusic.vue'
import CanvasRightClickMenu from '@/components-v2/presentation-editor/middle/right-click-menu/CanvasRightClickMenu.vue'
import LiveChat from '@/components-v2/presentation-editor/live-chat/LiveChat.vue'
import EffectMenuToogle from '@/components-v2/presentation-editor/middle/effects/EffectMenuToggle.vue'
import CorrectAnswerToggler from '@/components-v2/presentation-editor/middle/CorrectAnswerToggler.vue'
import SubmissionTogglerV2 from '@/components-v2/presentation-editor/middle/SubmissionTogglerModalV2.vue'
import ResultToggler from '@/components-v2/presentation-editor/middle/ResultToggler.vue'
import WordCloudGroupingToggler from '@/components-v2/presentation-editor/middle/WordCloudGroupingToggler.vue'
import OpenEndedGroupingButton from '@/components-v2/presentation-editor/middle/OpenEndedGroupingButton.vue'
import QaSession from '@/components/presentations/QaSession.vue'
import VoiceCall from '@/components-v2/voice-audio/VoiceCall.vue'
import CanvasArrowsNavigation from '@/components-v2/presentation-editor/middle/CanvasArrowsNavigation.vue'
import PowerpointPresenting from '@/components/UI/PowerpointPresenting.vue'
import CheatsheetToggleButton from '@/components-v2/presentation-editor/middle/CheatsheetToggleButton.vue'
import CheatsheetLayer from '@/components-v2/presentation-editor/middle/CheatsheetLayer.vue'
import LeaderboardVisibilityToggle from '@/components-v2/presentation-editor/middle/LeaderboardVisibilityToggle.vue'
import LatestLeaderboard from '@/components-v2/leaderboard/LatestLeaderboard.vue'
import {
  SET_CURRENT_SLIDE_MODE,
  FULL_SCREEN_MODE,
  EDIT_MODE,
} from '@/vuex/types'
import eventCategories from '@/constant/eventCategories'
import { INPUT_METHODS } from '@/constant/inputMethods.constants'
import QuestionImageButton from '../side-right/QuestionImageButton.vue'

const tracker = utils
  .gaTrackEventFactory({
    eventCategory: configs.US_PRESENTING_MODE,
    eventLabel: configs.LABEL_USER_INTERACTION,
  })
  .bind(utils)

const MAX_RIGHT_CLICK_VALUE = 3
const WORD_CLOUD_GROUPING_THRESHOLD = 2
const WORD_CLOUD_GROUPING_PRELOAD_THRESHOLD = 20

export default {
  components: {
    ContextMenu,
    Slide,
    CanvasPreview,
    CanvasChooseASlideType,
    CanvasTransitionBackgroundImage,
    CanvasLeaderboardMusic,
    CanvasRightClickMenu,
    LiveChat,
    EffectMenuToogle,
    QaSession,
    VoiceCall,
    QRcodePanel,
    QuestionImageButton,
    ResultToggler,
    WordCloudGroupingToggler,
    OpenEndedGroupingButton,
    CorrectAnswerToggler,
    FeedbackPanel,
    FeedbackPanelCollapsedButton,
    CanvasArrowsNavigation,
    SubmissionTogglerV2,
    PowerpointPresenting,
    CheatsheetToggleButton,
    CheatsheetLayer,
    LeaderboardVisibilityToggle,
    LatestLeaderboard,
  },
  mixins: [ToggleQRCodeMixin, FeedbackPanelMixin],
  data() {
    return {
      showContextMenu: false,
      isShowingControls: false,
      targetX: null,
      targetY: null,
      offsetX: null,
      offsetY: null,
      layerX: null,
      layerY: null,
      targetClick: null,
      isMSTeamsApp: !!utils.getParamValue('ms-teams', window.location.href),
      isFeedbackPanelOpen: false,
      isFeedbackPanelCollapsedButtonVisible: false,
      WORD_CLOUD_GROUPING_PRELOAD_THRESHOLD,
      isIOS: isIOS(),
      slideComponentRerenderKey: 0,
    }
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapGetters('leaderboard', [
      'isLeaderboardVisible',
      'isShowLeaderboardVisibilityToggle',
    ]),
    ...mapGetters(['wordsToDisplay']),
    ...mapGetters('liveStatsV2', ['canUseWordCloudEmqx']),
    ...mapState({
      presentation: (state) => state.presentation,
      isPlayDemoMode: (state) => state.isPlayDemoMode,
      currentUser: (state) => state.currentUser,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,
      voiceCall: (state) => state.voiceCall,
      isQRCodeVisible: (state) => state.isQRCodeVisible,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      numberOfUniqueWordsInGroup: (state) => state.slideActive.numberOfUniqueWordsInGroup,
      isScreenCapture: (state) => state.isScreenCapture,
      activePresentationPowerpointId: (state) => state.activePresentationPowerpointId,
      planBenefit: (state) => state.planBenefit,
    }),
    ...mapGetters(['isPresenting', 'isBackstage', 'isLastSlide', 'isStartPresentingFromLastSlide', 'isTextColourLight']),
    ...mapGetters('presentationChat', ['isFocusingChatInput', 'chatMessages']),
    ...mapGetters('slideRenderHandler', ['isSlideRenderInProgress']),
    ...mapGetters('presentationHotKeyModule', ['showCheatsheet', 'hotKeyTrackingData']),
    ...mapGetters('slideModule', ['slideActive']),
    isLockSubmissionInternalVersion() {
      return false
    },
    isSubmissionTogglerVisible() {
      const pollTypes = [
        'multipleChoice',
        'imageChoice',
        'openEnded',
        'scale',
        'wordCloud',
      ]

      return this.slideActive && pollTypes.includes(this.slideActive.type)
    },
    isShowTimeSubmission() {
      return this.hasTimeLimitOption
        && this.hasTimeLimit
        && !this.isSharingView
        && !this.isLockSubmissionInternalVersion
    },

    isChooseASlideTypeVisible() {
      // Wordaround to hide choose a slide type when creating new session
      // newly created session has no 'order' property
      if (!this.slideActive.order) {
        return false
      }
      return this.isNewPresentation || !this.slideActive.type
    },
    isQuizLobby() {
      const { type, quizStatus } = this.slideActive
      return type === 'pickAnswer' && quizStatus === QuizStatuses.LOBBY_SCREEN
    },
    isWordCloudSlide() {
      return this.slideActive.type === 'wordCloud'
    },
    isWordCloudOrOpenEnded() {
      return this.isWordCloudSlide || this.slideActive.type === 'openEnded'
    },
    isLeaderboardScreen() {
      return this.slideActive.type === 'leaderboard'
    },
    isQRCodeSlide() {
      const { type } = this.slideActive
      return type === 'qrcode' && this.$store.state.presentation.slides.some((slide) => slide.type === 'pickAnswer')
    },
    isSharingView() {
      return this.sharePresentation
    },
    isLiveChatVisible() {
      return this.presentation.isEnableChat &&
      !this.presentation.audiencePacing &&
      !this.presentation.privateMode &&
        this.isQuizLobby &&
        this.isPresenting &&
        !this.sharePresentation
    },
    isResultTogglerVisible() {
      const slideTypes = ['multipleChoice', 'imageChoice', 'openEnded', 'wordCloud', 'scale']
      return slideTypes.includes(this.slideActive.type) &&
         !this.sharePresentation
    },
    isCorrectAnswerTogglerVisible() {
      const { addCorrectOption, type } = this.slideActive
      return addCorrectOption && !this.sharePresentation
        && (type == 'multipleChoice' || type == 'imageChoice')
    },
    isChatOpenByDefault() {
      const { type, quizStatus } = this.slideActive
      if (this.chatMessages.length === 0) {
        return false
      }
      return (type === 'pickAnswer' &&
        quizStatus === QuizStatuses.LOBBY_SCREEN) ||
        type === 'qrcode'
    },
    hasPrevSlide() {
      return this.$store.getters.currentSlideIndex > 0
    },
    hasNextSlide() {
      return (
        this.$store.getters.currentSlideIndex <
        this.$store.state.presentation.slides.length - 1
      )
    },
    isShowingQRCodePanel() {
      return this.isPresenting && this.isQRCodeVisible
    },
    canShowFeedbackPanel() {
      return this.presentation.isEnablePrivateFeedback &&
        this.isPresentingOrBackstage &&
        this.isLastSlide
    },
    hasMoreThan5Slides() {
      return this.presentation.slides && this.presentation.slides.length >= 5
    },
    isShowingFeedbackCollapseButton() {
      return this.canShowFeedbackPanel &&
        this.isFeedbackPanelCollapsedButtonVisible
    },
    isShowingFeedbackPanel() {
      return this.canShowFeedbackPanel &&
        this.isFeedbackPanelOpen
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
    isContentSlideType() {
      return this.slideActive.type === 'freestyle'
    },
    hasTimeLimitOption() {
      const validTypes = [
        'imageChoice',
        'multipleChoice',
        'openEnded',
        'scale',
        'wordCloud',
      ]

      return this.slideActive && validTypes.includes(this.slideActive.type)
    },
    hasTimeLimit() {
      return !JSON.parse(this.$store.state.presentation.audiencePacing)
    },
    isWordCloudSubmissionLocked() {
      return this.slideActive.stopSubmission && this.isWordCloudSlide
    },
    isAllowedSmartGrouping() {
      if (this.canUseWordCloudEmqx) {
        return this.wordsToDisplay?.length >= WORD_CLOUD_GROUPING_THRESHOLD
      }
      return this.numberOfUniqueWordsInGroup >= WORD_CLOUD_GROUPING_THRESHOLD
    },
    noSubmittedWords() {
      return !this.wordsToDisplay || !this.wordsToDisplay.length
    },
    isWordCloudGroupingButtonVisible() {
      return this.isPresentingOrBackstage && this.isWordCloudSlide
    },
    isOpenEndedGroupingButtonVisible() {
      return this.slideActive.type === 'openEnded' && this.isPresentingOrBackstage
    },
    isShowSubmissionToggler() {
      if (this.planBenefit.interactivePresentation &&
        !this.planBenefit.interactivePresentation.advancedSubmissionControls) {
        return false
      }
      return this.isSubmissionTogglerVisible && !this.isLockSubmissionInternalVersion
    },
    isNotHavePlanBenefit() {
      if (this.planBenefit.interactivePresentation && !this.planBenefit.interactivePresentation.hideResults) {
        return true
      }
      return false
    },
  },
  watch: {
    isPresenting(isPresenting) {
      if (!isPresenting) {
        this.showContextMenu = false
        this.handleToggleWordCloudGrouping(this.slideActive.id, false)
        this.updateSlideActiveAction({
          isOpenEndedGroupingLayout: false,
          isOpenEndedGroupingLoading: false,
        })
      }
    },
    canShowFeedbackPanel(isPresentingLastSlide) {
      this.checkToShowFeedbackPanel(isPresentingLastSlide)
    },
    // Đóng feedback panel nếu như mở QR code panel
    isQRCodeVisible(isQRCodeVisible) {
      if (isQRCodeVisible) {
        this.isFeedbackPanelOpen = false
      }
    },

    // Show the collapsed button when the expanded panel is closed and vice versa
    isFeedbackPanelOpen(isOpen) {
      if (this.canShowFeedbackPanel) {
        this.isFeedbackPanelCollapsedButtonVisible = !isOpen
      }
    },

    isSlideRenderInProgress(newVal) { // re-render Slide component when activeSlide is updated
      if (newVal) {
        this.slideComponentRerenderKey++
        this.$nextTick(() => {
          EventBus.$emit('setPresentationDataDone')
          this.setSlideRenderInProgressAction(false)
        })
      }
    },
  },
  mounted() {
    this.handleSwipeEvent()
    EventBus.$on('context-menu: update showContextMenu', (value) => {
      this.showContextMenu = value
    })
    EventBus.$on('next-back-slide-arrows: update isShowingControls', (value) => {
      this.isShowingControls = value
    })
    EventBus.$on('onKeyboard', (e) => {
      this.handleSlideControlsKeydown(e)
    })
    EventBus.$on('eventHandleNextSlide', (type) => {
      this.$emit('handleNextSlideWhenPlayingQuiz', type)
    })
    EventBus.$on('word-cloud-smart-grouping: generated', (socketData) => {
      const {
        slideId, wordCloudSmartGrouping, numberOfWordsInGroup, numberOfUniqueWordsInGroup,
      } = socketData
      const hasReachedPreBuildLimit = numberOfUniqueWordsInGroup &&
        numberOfUniqueWordsInGroup >= this.WORD_CLOUD_GROUPING_PRELOAD_THRESHOLD
      if (slideId == this.slideActive.id) {
        this.updateSlideActiveAction({
          wordCloudSmartGrouping,
          numberOfWordsInGroup,
          numberOfUniqueWordsInGroup,
        })
        if (hasReachedPreBuildLimit) {
          EventBus.$emit('word-cloud-smart-grouping: pre-build', wordCloudSmartGrouping)
        }
      }
    })
  },
  destroyed() {
    EventBus.$off('context-menu: update showContextMenu')
    EventBus.$off('next-back-slide-arrows: update isShowingControls')
    EventBus.$off('onKeyboard')
    EventBus.$off('eventHandleNextSlide')
    EventBus.$off('word-cloud-smart-grouping: generated')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setCurrentUserAction', 'toggleQRCodePanelAction', 'setSyncPresentationAction']),
    ...mapActions('zoomApp', [
      'detachPresentationToZoomMeetingAction',
    ]),
    ...mapActions('presentationHotKeyModule', ['toggleCheatsheetAction', 'hideCheatsheetAction']),
    ...mapActions('slideRenderHandler', ['setSlideRenderInProgressAction']),
    ...mapActions('leaderboard', [
      'toggleLeaderboardVisibilityAction',
    ]),

    toggleCheatsheet(method) {
      this.toggleCheatsheetAction()
      this.isShowingControls = true
      if (!this.showCheatsheet) return
      this.trackToggleCheatsheet(method)
    },
    trackToggleCheatsheet(method) {
      const { eventCategory, presentationId, userId } = this.hotKeyTrackingData
      utils.mixpanelTracking(
        eventCategory,
        'Cheatsheet > Open',
        null,
        null,
        {
          method,
          presentationId,
          userId,
        },
      )
    },
    handleSwipeEvent() {
      const hammertime = new Hammer(this.$refs['slide-container'])
      hammertime.on('swipe', (ev) => {
        if (!this.isPresenting && !this.isBackstage) return
        if (ev.direction === Hammer.DIRECTION_RIGHT) {
          if (this.hasPrevSlide) this.selectPrevSlide('swipe')
        } else {
          tracker({ eventAction: 'User swiped to next slide' })
          if (this.hasNextSlide) this.selectNextSlide('swipe')
        }
      })
    },

    openContextMenu() {
      if (!this.isPresenting) return
      this.showContextMenu = true
    },

    closeContextMenu() {
      this.showContextMenu = false
    },
    selectPrevSlide(mode) {
      this.$emit('selectPrevSlide', mode)
      this.hideCheatsheetAction()
    },
    selectNextSlide(mode) {
      this.$emit('selectNextSlide', mode)
      this.hideCheatsheetAction()
    },
    isFocusingInput() {
      return this.isFocusingChatInput || this.slideActive.isFocusingSlideNoteInput
    },

    handleSlideControlsKeydown(e) {
      if (!this.isPresenting && !this.isBackstage) return

      // If popup in visible in leaderboard, do nothing
      if (this.slideActive.type === 'leaderboard'
       && this.slideActive.visiblePopup) return
      // If chatbox input is focusing, and the key is not Esc, then do nothing
      if (this.isFocusingInput() && !configs.EXIT_KEYS.includes(e.code)) return

      if (this.slideActive.type == 'pickAnswer' && this.$store.state.quizConfirmation && !this.sharePresentation) {
        if (this.$store.state.historyKeyboard == e.code) {
          this.$emit('handleNextSlideWhenPlayingQuiz', this.$store.state.quizConfirmationType)
        } else {
          this.$store.state.quizConfirmation = null
        }
        return
      }

      this.$store.state.historyKeyboard = e.code
      this._handleControlKeydown(e)
      if (this.slideActive.type === 'bulletPoints') this._handleNextBackBulletPointsIndex(e)
    },

    // eslint-disable-next-line sonarjs/cognitive-complexity
    _handleControlKeydown(e) {
      const arrPreventKeys = [
        'Enter',
        'Space',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
      ]
      if (this.sharePresentation && this.$store.state.isFocusInputCommentPresentation && arrPreventKeys.includes(e.code)) {
        return
      }
      if (
        configs.START_QUIZ_KEYS.includes(e.code) &&
        this.slideActive.type == 'pickAnswer' &&
        this.slideActive.quizStatus == constants.QuizStatuses.LOBBY_SCREEN &&
        !this.sharePresentation
      ) {
        EventBus.$emit('start-quiz')
        return
      }
      if (configs.NEXT_SLIDE_KEYS.includes(e.code)) {
        if (
          this.slideActive.type == 'pickAnswer' &&
          this.slideActive.quizStatus == constants.QuizStatuses.LOBBY_SCREEN &&
          !this.sharePresentation
        ) {
          EventBus.$emit('start-quiz')
          return
        }

        this.selectNextSlide('keyboard')
      }
      if (configs.LAST_SLIDE_KEYS.includes(e.code)) {
        this.selectPrevSlide('keyboard')
      }

      if (configs.EXIT_KEYS.includes(e.code)) {
        const presentFrom = utils.getParamValue('presentFrom')
        if (presentFrom === 'google-slide') {
          return
        }
        this.hideCheatsheetAction()
        if (this.isEnableAddinPowerpoint) return
        if (this.isMSTeamsApp) {
          return
        }
        if (this.isZoomReady) {
          this.detachPresentationToZoomMeetingAction()
          this.$router.push({
            name: 'ZoomPresentationList',
          })
          return
        }
        if (!e.shiftKey) {
          EventBus.$emit('close-backstage-window')
        }
        if (this.sharePresentation || this.isPlayDemoMode) {
          return
        }
        if (this.isQRCodeVisible) {
          this.handleToggleQrCode()
          return
        }
        if (this.$store.getters.isFullScreenMode) { // Exit presenting mode = Escape button
          tracker({
            eventAction: 'User switched to normal mode from full screen mode',
          })

          utils.setCurrentWindowMode()
          this.$http.put(
            configs.api.updatePresentation + this.$store.state.presentation.id,
            {
              presenting: false,
              socketId: Socket.getSocketId(),
              accessCode: this.$store.state.presentation.uniqueAccessCode,
            },
          )
          this.$router.replace({
            name: 'PresentationDetail',
            params: { id: this.$store.state.presentation.id },
          })
        }
        if (this.$store.getters.isWindowedMode) {
          tracker({
            eventAction: 'User switched to edit mode from presenting mode',
          })
          if (this.isMSTeamsApp) {
            return
          }
          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
          // TODO:
          // - Create "start" "stop" presentation API and move the scope below to server side
          // - There is duplicated code in ContextMenu.vue (stopPresenting), move it to server side too.
          if (this.slideActive.type == 'pickAnswer') {
            if (!this.$store.state.isAdmin) {
              // eslint-disable-next-line promise/catch-or-return
              SlideApi.updateSlideById(this.slideActive.id, {
                quizStatus: constants.QuizStatuses.LOBBY_SCREEN,
                socketId: Socket.getSocketId(),
                accessCode: this.presentation.uniqueAccessCode,
                activeSlide: this.slideActive.id,
                presentationId: this.presentation.id,
                presenting: false,
                trigger: '_handleControlKeydown in SlideWrapper.vue',
              })
              // eslint-disable-next-line promise/always-return
                .then(() => {}, () => {
                  this.setSyncPresentationAction(3)
                })
            }
          }

          if (this.presentation.id && !this.$store.state.isAdmin && !this.sharePresentation) {
            const idLastSlide = utils.getLastSlide(
              this.$store.state.presentation.slides,
            )
            const payload = {
              presenting: false,
              socketId: Socket.getSocketId(),
              activeSlidePreseting: this.slideActive.id,
              activeSlideAccessCode: this.presentation.uniqueAccessCode,
            }
            if (
              idLastSlide &&
              idLastSlide != this.$store.state.presentation.lastSlide
            ) {
              payload.lastSlide = idLastSlide
              this.$store.state.presentation.lastSlide = idLastSlide
            }
            this.$http
              .put(
                configs.api.updatePresentation + this.$store.state.presentation.id,
                payload,
              )
              .then(() => {}, () => {
                this.setSyncPresentationAction(3)
              })
          }
          // END OF TODO
          this.trackBackToEditor()
          this.$router.replace({
            name: 'PresentationDetail',
            params: { id: this.presentation.id },
          })
        }
      }
      if (
        configs.ENTER_FULL_SCREEN_KEYS.includes(e.code) &&
        this.$store.getters.isWindowedMode
      ) {
        tracker({
          eventAction: 'User switched to full screen mode using hotkeys',
        })
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)
      }
      if (e.code === 'Enter' && !this.sharePresentation) {
        EventBus.$emit('slide-handle-enter')
      }
      if (e.code === 'Space' && !this.sharePresentation) {
        EventBus.$emit('slide-handle-space')
      }
      this.handleQAScroll(e.code)
    },

    handleQAScroll(keyCode) {
      if ((keyCode === 'ArrowUp' || keyCode === 'ArrowDown') && (this.slideActive.type === 'question' || this.$store.state.showQnaSession)) {
        EventBus.$emit('slide-qr-scroll', keyCode)
      }
    },

    handleToggleQrCode() {
      this.toggleQrCode('PressEsc') // ToggleQRCodeMixin
    },

    _handleNextBackBulletPointsIndex(e) {
      if (e.key == 'ArrowDown') {
        if (
          this.slideActive.SlideOptions.length <=
            this.slideActive.bulletPointsIndex
        ) return
        EventBus.$emit('onKeyboard', {
          code: 'ArrowRight',
        })
      } else if (e.key == 'ArrowUp') {
        if (
          !this.slideActive.bulletPointsIndex ||
            this.slideActive.bulletPointsIndex < 1
        ) {
          return
        }
        EventBus.$emit('onKeyboard', {
          code: 'ArrowLeft',
        })
      }
    },

    handleCanvasRightClick(event) {
      if (!this.slideActive.id) return
      event.stopPropagation()
      if (this.isPresentingOrBackstage) return
      if (event.target.closest('.element-editor') || event.target.closest('.mce-editor')) return
      if (this.isContentSlideType) EventBus.$emit('content-slide-right-click-menu: hide')
      if (event) {
        this.targetX = event.x
        this.targetY = event.y
        this.offsetX = event.offsetX
        this.offsetY = event.offsetY
        this.layerX = event.layerX
        this.layerY = event.layerY
        this.targetClick = event.target
      } else {
        this.targetX = null
        this.targetY = null
        this.offsetX = null
        this.offsetY = null
        this.layerX = null
        this.layerY = null
        this.targetClick = null
      }
      this._addNumberOfClickToLocalValue()
      EventBus.$emit('canvas-right-click-menu: show')
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Canvas > Right click > Open canvas context menu',
      )
    },

    _addNumberOfClickToLocalValue() {
      const key = storageKeys.CANVAS_RIGHT_CLICK
      let numberOfClick = localStorage.getItem(`${this.currentUser.id}-${key}` || 0)
      numberOfClick++
      if (numberOfClick > MAX_RIGHT_CLICK_VALUE) {
        this.$store.state.isRightClickInfoBoxVisible = false
      } else {
        localStorage.setItem(`${this.currentUser.id}-${key}`, numberOfClick)
      }
    },

    async _updateSlide(params) {
      params.socketId = Socket.getSocketId()
      params.presenting = this.isPresenting
      params.accessCode = this.$store.state.presentation.uniqueAccessCode
      await this.$http.put(configs.api.updateSlide + this.slideActive.id, params)
    },

    trackBackToEditor() {
      const eventName = 'Stop presenting button > Stop presenting'
      const {
        eventCategory,
        presentationId,
        userId,
      } = this.hotKeyTrackingData
      utils.mixpanelTracking(eventCategory, eventName, null, null, {
        presentationId,
        userId,
        method: INPUT_METHODS.KEYBOARD,
      })
    },

    toggleCorrectAnswer(isShowCorrectAnswer) {
      const payload = {
        showCorrectOption: isShowCorrectAnswer,
      }
      if (isShowCorrectAnswer) {
        payload.showQuestionImage = false
      }
      this.updateSlideActiveAction(payload)
      this._updateSlide(payload)
      utils.mixpanelTracking(
        'Slide',
        'Edit setting',
        'Presenter edit setting show correct option',
        this.slideActive.showCorrectOption,
      )
    },
    toggleResult(isShowingResult, method) {
      const payload = {
        hideResult: !isShowingResult,
      }
      if (isShowingResult) {
        payload.showQuestionImage = false
      }
      this.updateSlideActiveAction(payload)
      const slideActiveId = this.slideActive.id
      const listShowedResult = JSON.parse(localStorage.getItem('list_showed_result_id') || '[]')
      if (!listShowedResult.includes(slideActiveId)) {
        listShowedResult.push(slideActiveId)
      }
      // if (!isShowingResult) {
      //   localStorage.setItem('list_showed_result_id', JSON.stringify(listShowedResult))
      // }
      this._updateSlide(payload)
      if (this.slideActive.type === 'openEnded') {
        EventBus.$emit('handleRemovePickOption')
      }

      const { eventCategory, presentationId, userId } = this.hotKeyTrackingData
      const eventLabel = 'Show/hide results'
      utils.mixpanelTracking(
        eventCategory,
        'Edit setting',
        eventLabel,
        isShowingResult,
        {
          method,
          presentationId,
          userId,
        },
      )
    },
    async handleToggleWordCloudGrouping(slideId, isShowingGroupWordCloud, callback) {
      const payload = {
        isGroupWordCloudWords: isShowingGroupWordCloud,
      }
      if (isShowingGroupWordCloud && this.isAllowedSmartGrouping) {
        try {
          const response = await SlideApi.wordCloudSmartGrouping(this.slideActive.id)
          if (response && response.data) {
            payload.wordCloudSmartGrouping = response.data
          }
        } catch (error) {
          Sentry.captureException(error)
          this.setSyncPresentationAction(3)
        }
      }
      if (slideId === this.slideActive.id) {
        if (this.isAllowedSmartGrouping) {
          await this._updateSlide(payload)
        }
        this.updateSlideActiveAction(payload)
        EventBus.$emit('toggleWordCloud', isShowingGroupWordCloud)
        if (typeof callback === 'function') {
          callback()
        }
      }
    },

    onOpenFeedbackPanel() {
      this.isFeedbackPanelOpen = true
      this.toggleQRCodePanelAction(false)
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.slide-container {
  transform-origin: top left;
  overflow: hidden;
  background-color: #fff;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  backface-visibility: hidden;
  -webkit-box-shadow: 1px 2px 6px 1px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 1px 2px 6px 1px rgba(0, 0, 0, 0.25);
  box-shadow: 1px 2px 6px 1px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &.is-showing-qrcode-panel,
  &.is-showing-feedback-panel {
  background-color: #000;
  }
}

.white-icon {
  filter: invert(1);
}
.backdrop {
  position: fixed;
  width: 80%;
  height: 100%;
  z-index: 999;
  top: 0;
  left: 21%;
  &.is-showing-qr-code-panel {
    transform: translate(20%);
  }
  &.is-showing-feedback-panel {
    transform: translate(-20%);
  }
}
.content-presenting {
  position: relative;
  height: 100%;
  transition: transform 0.5s ease;

  &.show-control {
    &::v-deep .slide-control {
      opacity: 1;
    }
    &::v-deep {
      .quiz-music-toggle, .escape-presenting, .private-mode, .freestyle-audio-toggle-container {
        opacity: 1;
      }
    }
  }
  &.is-showing-qrcode-panel {
    transform: translateX(10%) scale(0.8);
    overflow: hidden;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  &.is-showing-feedback-panel {
    transform: translateX(-10%) scale(0.8);
    overflow: hidden;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}
.canvas-pill {
  position: relative;
  bottom: 4rem;
  height: 48px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin-left: 1rem;
  padding-left : 1.25rem;
  padding-right: 1.2rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 27px;
  transition: 0.3s;
  &.white {
      background: rgba(0, 0, 0, 0.5);
    .hover-item::after{
      background: rgba(211, 215, 225, 0.2);
    }
    .live-chat__wrapper {
      &:hover {
        &:after {
          background-color: rgba(225, 225, 225, 0.2);
        }
      }
    }
  }

  &.no-background {
    background: transparent;
    backdrop-filter: unset;
  }
  &.is-wordcloud-or-openended {
    padding-right: 0.4rem;
    &.is-wc-submission-locked {
      &::v-deep .tooltip__wrapper.arrow-bottom::before {
        right: 11rem;
      }
    }
  }

  .is-qrcode-visible {
    z-index: 19;
  }
}

.slide-menu-toggle__wrapper {
  cursor: pointer;
  transition: opacity .3s ease;
  font-size: 18px;
  z-index: 30;

  .slide-menu-toggle-title {
    padding-left: 8px;
    margin-bottom: -2px;
  }
}
.live-chat__wrapper {
  padding-top: 0.5rem;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  z-index: 30;
  transition: all 0.2s ease;
  margin-left: 1rem;

  &::v-deep .chat-box__tip {
    top: -22px;
  }
  &:after {
    top: 4px;
    left: -4px;
    z-index: -1;
    content: "";
    width: 36px;
    height: 36px;
    border-radius: 50%;
    position: absolute;
  }
  &:hover {
    &:after {
      background-color: #ebebeb;
    }
  }
}
.effect-menu-toggle__wrapper {
  position: relative;
  cursor: pointer;
  font-size: 18px;
  z-index: 30;
  transition: all 0.2s ease;
  margin-left: 1rem;
}

.result_toggler {
  z-index: 30;
  // padding-top: 2px;
}
.show-qna-session {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 25;
  padding: 64px;

  .box-qna-session {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  @media (max-width: 768px) and (orientation: landscape) {
    padding-top: 86px;
    padding-bottom: 42px;
  }
}
.leaderboard-v2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 128;
  }
</style>
